export default [
    {
        path: '/',
        props: true,
        component: () => import('@/views/Dashboard'),
    },
];
